import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _StimulusEditInfo;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { Heading } from '@instructure/ui-heading';
import { RichContentInput, RCE_SINGLE_LINE_HEIGHT } from '@instructure/quiz-rce';
import { toErrors } from '../../../../util/instUIMessages';
import { IconUpdownLine } from '@instructure/ui-icons';
import { ToggleDetails } from '@instructure/ui-toggle-details';
import { SimpleSelect, TextInput, TOP, withStyleOverrides, FormFieldGroup, FormField } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Alert } from '@instructure/ui-alerts';
export var StimulusEditInfo = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_StimulusEditInfo = /*#__PURE__*/function (_Component) {
  function StimulusEditInfo() {
    var _this;
    _classCallCheck(this, StimulusEditInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StimulusEditInfo, [].concat(args));
    _defineProperty(_this, "inputErrors", function (field) {
      if (_this.props.errorsShowing) {
        var errorMap = _this.props.workingStimulus.getErrors().toJS() || {};
        return toErrors(errorMap[field] || []);
      }
    });
    _defineProperty(_this, "onOrientationChange", function (e, _ref) {
      var value = _ref.value;
      var newData = _this.props.workingStimulus.set('orientation', value);
      _this.props.modifyStimulus(newData);
    });
    _defineProperty(_this, "onTextInputChange", function (field) {
      return function (e) {
        var newData = _this.props.workingStimulus.set(field, e.target.value);
        _this.props.modifyStimulus(newData);
      };
    });
    _defineProperty(_this, "onBodyChange", function (e, _ref2) {
      var editorContent = _ref2.editorContent;
      var newData = _this.props.workingStimulus.set('body', editorContent);
      _this.props.modifyStimulus(newData);
    });
    return _this;
  }
  _inherits(StimulusEditInfo, _Component);
  return _createClass(StimulusEditInfo, [{
    key: "headerText",
    value: function headerText(stimulus) {
      if (stimulus.isTemporary()) {
        return stimulus.passage ? t('Add Passage') : t('Add Stimulus');
      } else {
        return stimulus.passage ? t('Edit Passage') : t('Edit Stimulus');
      }
    }
  }, {
    key: "renderOptionalLabel",
    value: function renderOptionalLabel(labelName) {
      var optionalText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('(optional)');
      return jsx("div", null, jsx("span", null, labelName), jsx("span", {
        css: this.props.styles.optionalLabel
      }, optionalText));
    }
  }, {
    key: "renderStimulusOrientationSelect",
    value: function renderStimulusOrientationSelect() {
      var stimulusOrientation = this.props.workingStimulus.get('orientation');
      return jsx("div", {
        css: this.props.styles.section
      }, jsx(SimpleSelect, {
        renderLabel: t('Orientation'),
        onChange: this.onOrientationChange,
        value: stimulusOrientation,
        renderBeforeInput: jsx(IconUpdownLine, {
          rotate: stimulusOrientation === TOP ? '0' : '90'
        })
      }, jsx(SimpleSelect.Option, {
        renderBeforeLabel: jsx(IconUpdownLine, {
          rotate: "90"
        }),
        id: "stimulus-orientation-select-option-left",
        value: "left"
      }, t('Questions to the right')), jsx(SimpleSelect.Option, {
        renderBeforeLabel: jsx(IconUpdownLine, null),
        id: "stimulus-orientation-select-option-top",
        value: "top"
      }, t('Questions below'))));
    }
  }, {
    key: "renderPassageAlert",
    value: function renderPassageAlert(stimulus) {
      if (!stimulus.passage || !this.props.shuffleQuestionsEnabled) {
        return null;
      }
      return jsx(Alert, {
        variant: "warning"
      }, t('The passage sections may not appear in their original order due to the shuffle setting.'));
    }
  }, {
    key: "renderInstructions",
    value: function renderInstructions(stimulus) {
      if (stimulus.passage) {
        return null;
      }
      return jsx("div", {
        css: this.props.styles.section
      }, jsx(TextInput, {
        renderLabel: this.renderOptionalLabel(t('Instructions')),
        onChange: this.onTextInputChange('instructions'),
        value: stimulus.get('instructions'),
        "data-automation": "sdk-stimulus-instructions-input"
      }));
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(stimulus) {
      if (stimulus.passage) {
        return null;
      }
      return jsx("div", {
        css: this.props.styles.section
      }, jsx(ToggleDetails, {
        defaultExpanded: true,
        variant: "filled",
        key: "options",
        summary: t('Options')
      }, this.props.stimulusOrientationEnabled ? this.renderStimulusOrientationSelect() : null, jsx("div", {
        css: this.props.styles.section
      }, jsx(TextInput, {
        renderLabel: this.renderOptionalLabel(t('Source URL'), t('(optional - not visible to students)')),
        onChange: this.onTextInputChange('sourceUrl'),
        value: stimulus.get('sourceUrl'),
        "data-automation": "sdk-source-url-input"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var stimulus = this.props.workingStimulus;
      var textAreaId = "stimulusBodyEdit_".concat(stimulus.id, "_").concat(this.props.isBankedContent);
      var stimulusBodyId = "stimulusBodyEdit_".concat(stimulus.id, "_body");
      var automationPrefix = stimulus.passage ? 'passage' : 'stimulus';
      return jsx(FormFieldGroup, {
        messages: this.inputErrors('onSelf'),
        description: jsx(ScreenReaderContent, null, t('Edit Stimulus'))
      }, jsx(Heading, {
        level: "h3",
        as: "h2"
      }, this.headerText(stimulus)), this.renderPassageAlert(stimulus), jsx("div", {
        css: this.props.styles.section
      }, jsx(TextInput, {
        messages: this.inputErrors('title'),
        renderLabel: t('Title'),
        isRequired: true,
        ref: this.props.setTitleRef,
        onChange: this.onTextInputChange('title'),
        value: stimulus.get('title'),
        "data-automation": "sdk-".concat(automationPrefix, "-title-input")
      })), this.renderInstructions(stimulus), jsx("div", {
        css: this.props.styles.section
      }, jsx(FormField, {
        id: stimulusBodyId
      }, jsx(RichContentInput, {
        actsAsInput: true,
        label: t('Content'),
        isRequired: true,
        messages: this.inputErrors('body'),
        textareaId: textAreaId,
        defaultContent: stimulus.get('body'),
        onKeyUp: this.onBodyChange,
        onBlur: this.onBodyChange,
        onChange: this.onBodyChange,
        height: RCE_SINGLE_LINE_HEIGHT
      }))), this.renderOptions(stimulus));
    }
  }]);
}(Component), _defineProperty(_StimulusEditInfo, "displayName", 'StimulusEditInfo'), _defineProperty(_StimulusEditInfo, "componentId", "Quizzes".concat(_StimulusEditInfo.displayName)), _defineProperty(_StimulusEditInfo, "propTypes", {
  isBankedContent: PropTypes.bool,
  stimulus: ImmutablePropTypes.record.isRequired,
  workingStimulus: ImmutablePropTypes.record.isRequired,
  errorsShowing: PropTypes.bool.isRequired,
  modifyStimulus: PropTypes.func.isRequired,
  setTitleRef: PropTypes.func,
  stimulusOrientationEnabled: PropTypes.bool.isRequired,
  styles: PropTypes.object,
  shuffleQuestionsEnabled: PropTypes.bool
}), _defineProperty(_StimulusEditInfo, "defaultProps", {
  isBankedContent: false,
  shuffleQuestionsEnabled: false,
  setTitleRef: function setTitleRef() {}
}), _StimulusEditInfo)) || _class);
export default StimulusEditInfo;